import { Directive, ElementRef, Input, OnInit, HostListener } from '@angular/core';

@Directive({
   selector: '[autofocus]'
})

export class AutofocusDirective implements OnInit {
   private focus = true;

   constructor(private el: ElementRef) {
   }

   ngOnInit() {
      if (this.focus) {
         window.setTimeout(() => {
            this.el.nativeElement.focus();
         });
      }
   }

   @Input() set autofocus(condition: boolean) {
      this.focus = condition !== false;
   }

   @HostListener('click', ['$event.target.id'])
   onClick(targetElement: any) {
      let element: HTMLElement;
      switch (targetElement) {
         case 'sections' : element = document.getElementById('section-name'); break;
         default :  element = document.getElementById('field-labelName'); break;
      }
      setTimeout(() => { element?.focus(); }, 100);
   }

}
